import Feedback from 'models/feedback';
import FeedbackView from 'views/feedback/feedback-view';
import _ from 'lodash';
import Chaplin from 'chaplin';
import $ from 'jquery';

const FeedbackService = function () {
  this.matchFeedback = function (feedbacks, value) {
    if (!feedbacks) {
      return null;
    }

    return _.find(feedbacks, function (feedback) {
      return _.isEqual(feedback.match, value);
    });
  };
  // when more than 2 or 3 params we should use an object {feedback, feedbackElement, feedbackState, possibleStates, callbacks}
  this.renderFeedbackWithElementState = function (feedback, feedbackElement, feedbackState, possibleStates, callbacks) {
    callbacks = callbacks || {};

    this.triggerElement = feedbackElement;
    feedbackElement.removeClass(possibleStates.join(' '));
    feedbackElement.addClass(feedbackState);

    if (!feedback) {
      if (typeof callbacks.noFeedback === 'function') {
        callbacks.noFeedback();
      }
      return;
    }

    feedback = new Feedback(_.merge({}, feedback, { feedbackState: feedbackState }));
    if (!feedback.get('blocks')) {
      if (typeof callbacks.noFeedback === 'function') {
        callbacks.noFeedback();
      }
      return;
    }

    feedbackElement.addClass(`${feedbackState}-feedback-showing`);

    if (callbacks.unloading) {
      callbacks.origUnloading = callbacks.unloading;
    }

    callbacks.unloading = function () {
      feedbackElement.removeClass(`${feedbackState}-feedback-showing`);
      if (typeof callbacks.origUnloading === 'function') {
        callbacks.origUnloading();
      }
    };
    this.renderFeedback(feedback, callbacks);
  };

  this.renderFeedback = function (feedback, callbacks) {
    Chaplin.mediator.publish('block:feedback', feedback, callbacks);
  };

  this.removeFeedback = function (view, feedback) {
    const subviewsByName = view.pageView.subviewsByName;
    let feedbackRegion;
    if (feedback.inline) {
      feedbackRegion = 'inline-feedback';
      view.pageView.removeSubview(subviewsByName[feedbackRegion]);
      // inline-feedback creates a wrapper class that needs to be removed too.
      $(`.${feedbackRegion}`).remove();
    } else {
      feedbackRegion = feedback.region || 'feedback';
      view.pageView.removeSubview(subviewsByName[feedbackRegion]);
    }
  };

  this.displayFeedback = function (view, feedback, callbacks) {
    const viewOptions = {
      model: feedback,
      pageView: view,
      script: view.script ? view.script.feedback : undefined,
      callbacks: callbacks,
      containerMethod: feedback.get('replace') ? 'html' : 'append',
    };
    const inlineFB = 'inline-feedback';
    if (feedback.get('region')) {
      view.registerRegion(feedback.get('region'), `.${feedback.get('region')}`);
      viewOptions.region = feedback.get('region');
    } else if (feedback.get('inline') && this.triggerElement) {
      const inlineFeedback = view.subviewsByName[inlineFB];
      if (inlineFeedback !== undefined) {
        inlineFeedback.$el.parent().detach().appendTo(this.triggerElement);
      } else {
        $(`<div class="${inlineFB}"></div>`).appendTo(this.triggerElement);
        view.registerRegion(inlineFB, `.${inlineFB}`);
      }
      viewOptions.region = inlineFB;
    }

    const feedbackView = new FeedbackView(viewOptions);
    view.subview(feedbackView.region, feedbackView);
    view.listenTo(feedbackView, 'feedback:close', function (subview) {
      subview.container.attr('role', '');
      view.removeSubview(subview);
      if (callbacks && callbacks.afterRemoved) {
        callbacks.afterRemoved();
      }
    });
    view.listenTo(feedback, 'change:state', (model, state) => {
      if (state === 'loaded') {
        feedbackView.play();
      }
    });
  };
};

export default new FeedbackService();
